module.exports = __webpack_public_path__ + "static/media/Mail-Outline.8f7556fe.svg";